import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert } from 'react-bootstrap';
import {LOGIN_STATE} from '../../../../services/Api/constants';
import {Redirect, NavLink} from 'react-router-dom';
import AppPage from '../../../AppPages';
import pckg from '../../../../../pckg';


class Login extends Component {

    static contextTypes = { api: PropTypes.object };

    state = {};

    constructor(props){
        super(props);

        this.onFormChange = this.onFormChange.bind(this);
        this.logIn = this.logIn.bind(this);
    }

    onFormChange = ( {target} )=>{
        this.setState({ [target.name]: target.value});
    };

    logIn = (e)=>{
        e.preventDefault();

        const {user, pass} = this.state;

        if( !user || !pass )
            return;

        this.context.api.logIn( this.state.user, this.state.pass);
    };

    shouldRedirect(){
        if( this.props.loggedIn === LOGIN_STATE.LOGGED_IN ) {
            return <Redirect to="/"/>;
        }
        return null;
    }

    render() {
        return (

            <AppPage>

                <div className="row">

                    <div className="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">

                        {this.shouldRedirect()}


                        <form onChange={this.onFormChange} onSubmit={this.logIn}>
                            <div className="card">

                                <div className="card-header">
                                    <h3 className="card-title">Login</h3>
                                </div>
                                <div className="card-content">

                                    { this.props.loggedIn === LOGIN_STATE.BAD_CREDENTIALS?
                                        <Alert bsStyle='danger'>Usuario y contraseña incorrectos.</Alert>:null}

                                    { this.props.loggedIn === LOGIN_STATE.LOGIN_ERROR?
                                        <Alert bsStyle='danger'>Parece que hubo un error en la conexión.</Alert>:null}

                                    { this.props.loggedIn === LOGIN_STATE.LOGIN_BLOCKED?
                                        <Alert bsStyle='danger'>Demasiados intentos fallidos, tu IP ha sido bloqueada.</Alert>:null}

                                    <div className="form-group">
                                        <label>Usuario</label>
                                        <input
                                            placeholder="Escribe tu usuario"
                                            className="form-control input-no-border"
                                            name='user'
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Contraseña</label>
                                        <input
                                            type="password"
                                            placeholder="Escribe tu contraseña"
                                            className="form-control input-no-border"
                                            name='pass'
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="card-footer text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-fill btn-wd"
                                    >
                                        Entrar
                                    </button>
                                    <hr/>
                                    <NavLink to='/forgot-password'><small>Olvidé mi contraseña</small></NavLink>
                                    <br/>
                                    v {pckg.version}

                                </div>

                            </div>
                        </form>
                    </div>

                </div>

            </AppPage>

        );
    }
}

const mapStateToProps = ( {api:{loggedIn, loading}} )=>{
    return {
        loggedIn,
        loading
    };
};

export default connect(mapStateToProps)(Login);




// WEBPACK FOOTER //
// ./src/App/scenes/AppPages/scenes/Login/index.jsx